module.exports = __webpack_public_path__ + "img/banner.cac781bb.png";